export const sameAsLinks = [
    "https://www.youtube.com/@k-wpropertymanagement5470",
    "https://www.instagram.com/kwproperty",
    "https://twitter.com/KWPropertyM",
    "https://www.facebook.com/KWPropertyManagement",
    "https://www.linkedin.com/company/k-w-property",
    "https://www.google.com/search?kgmid=/g/11b73v3l1k",
    "https://maps.app.goo.gl/FvPMCDRYwqi9N51WA"
];